import {Application} from '../types';

import {
    useApplicationQuery,
    useCreateApplicationMutation,
    useDeleteApplicationMutation,
    useUpdateApplicationMutation,
} from './useApplicationsQuery';

// FNP-947: the single record comes from React Query. Return shape unchanged so
// the pages and forms consuming this hook did not change.
export const useApplication = (applicationId?: string) => {

    const {
        data: record,
        isLoading,
        refetch
    } = useApplicationQuery(applicationId);

    const createMutation = useCreateApplicationMutation();
    const updateMutation = useUpdateApplicationMutation();
    const deleteMutation = useDeleteApplicationMutation();

    // FETCH
    const fetchRecord = () => {
        if (typeof applicationId === 'undefined') {
            throw new Error('applicationId is required parameter');
        }
        refetch();
    };

    // CREATE, UPDATE, DELETE
    const createRecord = (values: Application) => {
        createMutation.mutate(values);
    };

    const updateRecord = (values: Application) => {
        if (typeof applicationId === 'undefined') {
            throw new Error('applicationId is required parameter');
        }

        updateMutation.mutate({
            id: applicationId,
            record: values,
        });
    };

    const deleteRecord = () => {
        if (typeof applicationId === 'undefined') {
            throw new Error('applicationId is required parameter');
        }
        deleteMutation.mutate(applicationId);
    };

    return {
        record,
        loading: isLoading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
